import { apiResourceUrl } from "@ploy-lib/core";
import { BaseResource } from "./BaseResource";
export var ExcelFunctionType;
(function (ExcelFunctionType) {
    ExcelFunctionType[ExcelFunctionType["Empty"] = 0] = "Empty";
    ExcelFunctionType[ExcelFunctionType["CopyPasteVariant"] = 1] = "CopyPasteVariant";
    ExcelFunctionType[ExcelFunctionType["FileVariant"] = 2] = "FileVariant";
})(ExcelFunctionType || (ExcelFunctionType = {}));
export class ExcelFunctionResource extends BaseResource {
    pk() {
        return this.name?.toString();
    }
    static getEndpointExtra() {
        return {
            ...super.getEndpointExtra(),
            dataExpiryLength: 120 * 1000,
            invalidIfStale: true
        };
    }
    static generateDownloadLink(name) {
        return `${this.urlRoot}/${name}/download`;
    }
}
ExcelFunctionResource.urlRoot = apiResourceUrl("decisionTableFunctions");
export class ExcelFunctionValidationResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.valid = false;
        this.inputs = [];
        this.outputs = [];
    }
    pk() {
        return this.inputHash?.toString();
    }
}
ExcelFunctionValidationResource.urlRoot = apiResourceUrl("decisionTableFunctions/validate");
//# sourceMappingURL=ExcelFunctionResource.js.map